<template>
  <div class="bidding-plan-page">
      <div class="page-header">
          <h2 class="page-title">招标项目计划</h2>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">
              新增计划
          </el-button>
      </div>

      <!-- 数据表格 -->
      <div class="table-section">
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
          class="data-table"
        >
          <el-table-column label="NO." width="60" align="center">
            <template slot-scope="scope">
              {{ (pagination.pageNum - 1) * pagination.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="招标项目名称" show-overflow-tooltip />
          <el-table-column prop="planCode" label="计划公告编码" show-overflow-tooltip />
          <el-table-column prop="noticeType" label="公告类型" align="center" />
          <el-table-column prop="submitTime" label="提交时间" align="center" />
          <el-table-column prop="publishTime" label="发布时间" align="center" />
          <el-table-column prop="publishStatus" label="发布状态" align="center" />
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          background
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
  </div>
</template>

<script>
import { getBuildPlanList } from '@/api/agent/api'
export default {
  name: 'BiddingPlan',
  data() {
    return {
      loading: false,
      searchForm: {
        publishDateStart: '',
        publishDateEnd: '',
        projectName: ''
      },
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    // 查询
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchList()
    },
    // 重置
    handleReset() {
      this.searchForm.publishDateStart = ''
      this.searchForm.publishDateEnd = ''
      this.searchForm.projectName = ''
      this.pagination.pageNum = 1
      this.fetchList()
    },
    // 新增
    handleAdd(){
        this.$router.push({ path: '/agentHome/biddingPlanAdd' })

    },
    // 分页当前页改变
    handleCurrentChange(page) {
      this.pagination.pageNum = page
      this.fetchList()
    },
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.fetchList()
    },
    // 获取列表
    async fetchList() {
      this.loading = true
      try {
        const res = await getBuildPlanList({
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
        })
        
        if (res.code === 200) {
          this.tableData = (res.data.list || []).map(item => ({
            ...item,
            noticeType: item.planNoticeType === 0 ? '招标计划' : '其他',
            publishStatus: item.publishStatus === 0 ? '未发布' : '已发布',
            submitTime: item.submitTime ? item.submitTime.replace('T', ' ') : '',
            publishTime: item.publishTime ? item.publishTime.replace('T', ' ') : ''
          }))
          this.pagination.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '获取列表失败')
          this.tableData = []
          this.pagination.total = 0
        }
      } catch (error) {
        this.$message.error('获取列表失败，请稍后重试')
        this.tableData = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(bidding-plan-page);
</style>